import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LanguageService } from '../demo/service/language.service';
import { TranslateService } from '@ngx-translate/core';
import { languages } from '../demo/constants/languages';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];

    languages: any[] = languages;
    selectedLanguage!: string;

    constructor(private languageService: LanguageService, private translateService: TranslateService) { }

    ngOnInit() {
        this.model = [
            {
                label: 'Customer Management',
                icon: 'pi pi-users',
                url: '/home/customers/search',
                translationKey: 'CUSTOMER_MANAGEMENT'
            },
            { separator: true },
            {
                label: 'Payment Verifications',
                icon: 'pi pi-wallet',
                url: '/home/payment-verifications',
                translationKey: 'PAYMENT_VERIFICATIONS'
            },
            { separator: true },
            {
                label: 'Pending Documents',
                icon: 'pi pi-file-pdf',
                url: '/home/documents',
                translationKey: 'PENDING_DOCUMENTS'
            },
            { separator: true },
            {
                label: 'Vehicle Makes',
                icon: 'pi pi-car',
                url: '/home/vehicle-makes',
                translationKey: 'VEHICLE_MAKES'
            },
            { separator: true },
            {
                label: 'Insurance Providers',
                icon: 'pi pi-briefcase',
                url: '/home/insurance-providers',
                translationKey: 'INSURANCE_PROVIDERS'
            },
            { separator: true },
            {
                label: 'User Management',
                icon: 'pi pi-users',
                url: '/home/users',
                translationKey: 'USER_MANAGEMENT'
            },
            { separator: true },
            {
                label: 'Reports',
                icon: 'pi pi-chart-line',
                url: ['/home/reports'],
                translationKey: 'REPORTS'
            },
        ];
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }
}
